import { Flex, SearchFilterTag, theme } from '@/components';
import { t } from '@/i18n';
import {
  KsAggregationTargetTypeLabelModifier,
  KsAnalysisAxisLabelModifier,
} from '@/utils/enum';
import { type FC, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import type {
  KsAnalysisSearchFormType,
  KsAnalysisSearchKeys,
} from '../../_models/ks-analysis-search';

type FieldKey = (typeof KsAnalysisSearchKeys)[number];

export const KsAggregationTags: FC = () => {
  const { token } = theme.useToken();
  const { control, setValue } = useFormContext<KsAnalysisSearchFormType>();
  const aggregationTargetType = useWatch({
    control,
    name: 'aggregationTargetType',
  });
  const analysisAxis = useWatch({ control, name: 'analysisAxis' });
  const value = useMemo<{ key: FieldKey; value: string }[]>(() => {
    return [
      ...(aggregationTargetType
        ? [
            {
              key: 'aggregationTargetType' as const,
              value: `${t('aggregation-target')}: ${KsAggregationTargetTypeLabelModifier[aggregationTargetType]}`,
            },
          ]
        : []),
      ...(analysisAxis
        ? [
            {
              key: 'analysisAxis' as const,
              value: `${t('axis-of-analysis')}: ${KsAnalysisAxisLabelModifier[analysisAxis]}`,
            },
          ]
        : []),
    ];
  }, [aggregationTargetType, analysisAxis]);

  return (
    <Flex
      gap={8}
      style={{ background: token.colorBgLayout, padding: 5 }}
      wrap="wrap"
    >
      {value.map((v) => (
        <SearchFilterTag
          closable={v.key === 'analysisAxis'}
          onClose={() => {
            setValue(v.key, null as never);
          }}
          key={v.key}
          label={v.value}
        />
      ))}
    </Flex>
  );
};
